module.exports = __webpack_public_path__ + "static/media/stefan.1f1fcb8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wizard/contact/stefan.png
// module id = 1484
// module chunks = 0